import classnames from 'classnames';
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const Accordion = ({
  children,
  className,
  multiple
}) => {
  const classes = classnames(className);
  const dataProps = {};
  if (multiple) {
    dataProps['data-allow-multiple'] = true;
  } else {
    dataProps['data-allow-toggle'] = true;
  }
  return /*#__PURE__*/_jsx("div", {
    className: classes,
    ...dataProps,
    children: children
  });
};